export const messageModelConstants = {

    ACTION_SAVE: 'PREDEFINED_MESSAGE_ACTION_SAVE',

    KICK_REQUEST: 'MESSAGE_MODEL_KICK_REQUEST',
    KICK_SUCCESS: 'MESSAGE_MODEL_KICK_SUCCESS',
    KICK_FAILURE: 'MESSAGE_MODEL_KICK_FAILURE',
 
    GETALL_REQUEST: 'MESSAGE_MODEL_GETALL_REQUEST',
    GETALL_SUCCESS: 'MESSAGE_MODEL_GETALL_SUCCESS',
    GETALL_FAILURE: 'MESSAGE_MODEL_GETALL_FAILURE',

    GETONE_REQUEST: 'MESSAGE_MODEL_GETONE_REQUEST',
    GETONE_SUCCESS: 'MESSAGE_MODEL_GETONE_SUCCESS',
    GETONE_FAILURE: 'MESSAGE_MODEL_GETONE_FAILURE',

    DELETE_REQUEST: 'MESSAGE_MODEL_DELETE_REQUEST',
    DELETE_SUCCESS: 'MESSAGE_MODEL_DELETE_SUCCESS',
    DELETE_FAILURE: 'MESSAGE_MODEL_DELETE_FAILURE',
};
